'use strict';

var _vueLoader = require('./vue-loader');

/*
This is used to set shopify's cdn url on runtime as base url for async vue components load
 */
// eslint-disable-next-line no-undef
if (WEBPACK_ENV !== 'development') {
  // eslint-disable-next-line camelcase, no-undef
  __webpack_public_path__ = window.theme.assetUrl;
} /* eslint-env browser */

var activeApps = [];
window.theme.vue.availableApps.forEach(function (app) {
  var newApp = new _vueLoader.VueLoader(app.id, app.data, app.type, app.path);
  activeApps.push(newApp);
  newApp.init();
});

if (Shopify.designMode) {
  // editor mode helper function
  // eslint-disable-next-line func-style
  var registerNewApps = function registerNewApps(event) {
    var eventSectionId = event.detail.sectionId;
    event.target.querySelectorAll('div[data-app-id="' + eventSectionId + '"]').forEach(function (appElement) {
      var appType = appElement.getAttribute('data-app-type');
      // eslint-disable-next-line no-eval
      eval(document.getElementById(eventSectionId + '-' + appType).innerHTML);
    });
  };
  // Handle theme editor events
  document.addEventListener('shopify:section:load', function (event) {
    var eventSectionId = event.detail.sectionId;
    registerNewApps(event);
    window.theme.vue.availableApps.forEach(function (app) {
      // check if a new section has got apps
      if (app.id === eventSectionId) {

        var newApp = new _vueLoader.VueLoader(app.id, app.data, app.type, app.path);
        activeApps.push(newApp);
        newApp.init();

        /*
        // create instances for apps in the new section
        if (appTypeClass[app.type]) {
          const newApp = new appTypeClass[app.type](app.id, app.data);
          activeApps.push(newApp);
          newApp.init();
        } else {
          console.error(`App "${app.type}" was not registered`);
        }
        */
      }
    });
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var eventSectionId = event.detail.sectionId;
    var newActiveApps = [];
    var newAvailableApps = [];

    activeApps.forEach(function (app) {
      // check if a unloaded section had apps
      if (app.getSectionId() === eventSectionId) {
        // turn off and unmount apps from unloaded section
        app.kill();
      } else {
        // save untouched apps aside
        newActiveApps.push(app);
      }
    });
    window.theme.vue.availableApps.forEach(function (app) {
      // check if a unloaded section had apps
      if (app.id !== eventSectionId) {
        // save untouched apps aside
        newAvailableApps.push(app);
      }
    });
    // reinit global app lists
    window.theme.vue.availableApps = newAvailableApps;
    activeApps = newActiveApps;
  });
}